@if (cynnalAChadw) {
  <div>
    <div class="flex-container">
      <div class=" neges-cynnalachadw">
        <div class="mat-headline mt-2">
          <fa-icon icon="wrench" class="mr-4"></fa-icon> Gwaith cynnal a chadw / Maintenance in progress
        </div>
        <div class="mat-subheading-2">
          Nid yw'r gwasanaeth hwn ar gael rhwng {{ cynnalAChadwCychwyn | date: "dd/MM/yyyy HH:mm" }} a {{
          cynnalAChadwGorffen | date: "dd/MM/yyyy HH:mm" }} oherwydd gwaith cynnal a chadw angenrheidiol. Rydym
          yn
          ymddiheuro am unrhyw anghyfleustra.
        </div>
        <div class="mat-subheading-2">
          This service is currently unavailable between {{ cynnalAChadwCychwyn | date: "dd/MM/yyyy HH:mm" }} and
          {{ cynnalAChadwGorffen | date: "dd/MM/yyyy HH:mm" }} due to essential maintenance
          work. We
          apologise for any
          inconvenience.
        </div>
        <div class="mat-body-1">
          <fa-icon icon="car" class="mr-4"></fa-icon> Asedau Fflyd - Cyngor Gwynedd
        </div>
      </div>
    </div>
  </div>
} @else {
  <app-sidebar></app-sidebar>
}

